import { fetchAuthSession } from "aws-amplify/auth"

export const getToken = async () => {
  try {
    const session = await fetchAuthSession({ forceRefresh: true })
    // Use access token instead of ID token for API authentication
    // Access tokens are shorter and designed for API authorization
    return session.tokens?.idToken?.toString()
  } catch (error) {
    console.error("Error fetching auth session:", error)
    throw error
  }
}
